import { render, staticRenderFns } from "./UsersLinkPage.vue?vue&type=template&id=7f641e5c&"
import script from "./UsersLinkPage.vue?vue&type=script&lang=js&"
export * from "./UsersLinkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports